import { useDatasourceId, useQueryId, useSeriesId } from '@/hooks';
import { useGetQueryStepsQuery } from '@/features/query-builder/queriesApiSlice';
import { useAppSelector } from '@/store/hooks';
import { selectLastUpdateMethod } from '@/features/query-builder-steps/queryBuilderStepsSlice';
import { useGetSavedQueryStepsQuery } from '@/features/query-builder/savedQueriesApiSlice';
import { LAST_UPDATE_METHOD } from '@/features/query-builder-steps/constants';

export const useLoadSteps = (skip = false) => {
  const datasourceId = useDatasourceId();
  const queryId = useQueryId();
  const seriesId = useSeriesId();
  const lastUpdateMethod = useAppSelector(selectLastUpdateMethod);

  const isBackendSync = lastUpdateMethod === LAST_UPDATE_METHOD.backendSync;

  const requiredQuerySkipCondition = !(queryId && isBackendSync);

  const requiredSavedQuerySkipCondition = !(seriesId && isBackendSync);

  const queryResult = useGetQueryStepsQuery(
    { datasourceId, queryId },
    { skip: requiredQuerySkipCondition || skip },
  );

  const savedQueryResult = useGetSavedQueryStepsQuery(
    { datasourceId, seriesId },
    { skip: requiredSavedQuerySkipCondition || skip },
  );

  if (seriesId) return savedQueryResult;

  return queryResult;
};
